import { render, staticRenderFns } from "./ReporteVentaPeriodos.vue?vue&type=template&id=574573c5&scoped=true"
import script from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
export * from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
import style0 from "./ReporteVentaPeriodos.vue?vue&type=style&index=0&id=574573c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574573c5",
  null
  
)

export default component.exports